// Vue, Vuex, Router and Axios
import Vue from "vue"
import Vuex from 'vuex'
import VueRouter from "vue-router"
import axios from 'axios'

// Custom CSS
require('normalize.css');
require('../css/app.css');
require('../css/fonts.css');

// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

require('../css/element-ui-theme/index.css');

import locale from 'element-ui/lib/locale/lang/es';

// Font Awesome Icons
require('../css/font-awesome/css/all.min.css');
// Moment JS with Spanish Translation

import moment from 'moment'

require( 'moment/locale/es' );
// Animate.css
import 'animate.css'

Vue.use( Vuex );
Vue.use( VueRouter );
Vue.use( ElementUI, { locale } );
Vue.use( require('vue-moment') );

window.Vue = Vue;
window.axios = axios;
window._ = require('lodash');
window.moment = moment;
window.versionApp = 'v 2.0.1.2';

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json'
};

if (window.sessionStorage.getItem('vsem_session')) {
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('vsem_session');
}
